// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f0373ad7","239":"60011df2","453":"61829909","455":"e9300f29"}[chunkId] + ".chunk.js";
};